import styled from 'styled-components';
import { STitle as SGenericTitle } from 'components/Typography/Title/styles';

export const STitle = styled(SGenericTitle)`
    margin-bottom: 2.5rem;
`;
